import React from 'react';
import { connect } from "react-redux";
import login from "../../actions/login";
import { clientID } from "../../url";
import MainLayout from "../Layout/Layout";
import { Row, Typography } from "antd";

class Login extends React.Component {
  googleInterval = null;

  componentDidMount() {
    this.initializeGoogleSignIn();
  }

  componentWillUnmount() {
    if (this.googleInterval) {
      clearInterval(this.googleInterval);
    }
  }

  initializeGoogleSignIn = () => {
    if (window.google && window.google.accounts) {
      this.renderGoogleButton();
    } else {
      this.googleInterval = setInterval(() => {
        if (window.google && window.google.accounts) {
          clearInterval(this.googleInterval);
          this.renderGoogleButton();
        }
      }, 100);
    }
  };

  renderGoogleButton = () => {
    window.google.accounts.id.initialize({
      client_id: clientID,
      callback: this.handleLogin
    });

    window.google.accounts.id.renderButton(
      document.getElementById("googleSignIn"),
      {
        theme: "outline",
        size: "large",
        text: "signin_with"
      }
    );
  };

  handleLogin = (response) => {
    // response.credential es un JWT
    this.props.login(response);
  };

  render() {
    return (
      <MainLayout title={'logo'} size={'medium'}>
        <Row justify="center" className="w-100">
          <div className="login-panel">
            <Typography.Title level={4}>Reportes Comerciales</Typography.Title>
            <Typography.Text>
              Inicie sesión con su cuenta corporativa para consultar y exportar los reportes.
            </Typography.Text>
            <div className="login-google-button" id="googleSignIn"></div>
          </div>
        </Row>
      </MainLayout>
    );
  }
}

export default connect(null, { login })(Login);
